import { EnumsShowStatus, urls } from "src/constant";
import { FTCanvasStore, FTImageStore } from "src/store";
import {
  IconArrawRight,
  IconClose,
  IconVideo,
  IconVideoLarge
} from "src/assets";
import {
  LocalStorageManager,
  SHOW_VIDEO_LINK_POPOVER_KEY
} from "src/utils/local";
import React, { useEffect, useState } from "react";
import { autorun, set } from "mobx";
import { useIsMobile, useLanguage } from "src/hooks";

import FTButton from "../FTButton";
import { Popover } from "antd";
import clsx from "clsx";
import styles from "./LinkToVideoPopover.module.scss";
import { withPublicUrl } from "src/utils";

export interface IDownloadWithPopoverProps {
  className?: string;
}

export default function VideoLinkWithPopover(props: IDownloadWithPopoverProps) {
  const { className } = props;
  const triggerRef = React.useRef<HTMLButtonElement>(null);
  const { t } = useLanguage();
  const triggerPosition = React.useRef({ x: 0, y: 0, width: 0, height: 0 });
  const [contentStyle, setContentStyle] = React.useState<
    React.CSSProperties | undefined
  >();
  const popoverRef = React.useRef<any>(null);
  const [popoverVisible, setPopoverVisible] = React.useState(
    // true
    false
  );
  const isMobile = useIsMobile();
  // const [showStatus, setShowStatus] = useState(EnumsShowStatus.origin);
  const handleVisibleChange = (visible) => {
    // console.log("handleVisibleChange", visible);
    // setPopoverVisible(visible);
  };

  const handleClose = () => {
    handleVisibleChange(false);
    FTCanvasStore.closeVideoLinkPopover();
  };

  // React.useEffect(() => {
  //   const dispose = autorun(() => {
  //     // setShowStatus(FTImageStore.showStatus);
  //     setPopoverVisible(FTCanvasStore.videoLinkPopoverVisible);
  //   });
  //   return () => {
  //     dispose();
  //   };
  // }, []);

  useEffect(() => {
    const close = () => {
      if (!isMobile) {
        return;
      }
      FTCanvasStore.closeVideoLinkPopover();
      handleVisibleChange(false);
    };
    document.body.addEventListener("click", close);
    return () => {
      document.body.removeEventListener("click", close);
    };
  }, [isMobile]);

  // React.useEffect(() => {
  //   if (showStatus === EnumsShowStatus.result) {
  //     const hasKey = LocalStorageManager.getItem(SHOW_VIDEO_LINK_POPOVER_KEY);
  //     if (!hasKey) {
  //       console.log("setPopoverVisible",true);
  //       handleVisibleChange(true);
  //       LocalStorageManager.setItem(
  //         SHOW_VIDEO_LINK_POPOVER_KEY,
  //         true,
  //         1000 * 60 * 60 * 24
  //       );
  //     }
  //   }
  // }, [showStatus]);

  useEffect(() => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      triggerPosition.current = {
        x: rect.left,
        y: rect.top,
        width: rect.width,
        height: rect.height
      };
    }
  }, []);

  // const handleClose = () => {
  //   handleVisibleChange(false);
  // };

  const popoveProps: any = {
    showArrow: false
  };
  const FTPopoverContent = () => {
    return (
      <section
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={clsx(
          styles.video_link_modal,
          isMobile && styles.modal_mobile
        )}>
        {/* <div className={clsx(styles.download_modal_mask)}></div> */}
        <div
          className={clsx(styles.video_link_modal_content)}
          style={contentStyle}>
          {/* <div className={clsx(styles.video_link_modal_title)}>
          <span>{t('download_popover_title')}</span>
          <span
            className={clsx(styles.video_link_modal_title_close)}
            onClick={handleClose}>
            <IconClose width={12} height={12} />
          </span>
        </div> */}
          <div className={styles.popover_title}>
            <div className={styles.popover_title_left}>
              <IconVideoLarge />
              <span>{t("video_link_modal_title")}</span>
            </div>
            <div className={styles.close}>
              <IconClose width={12} height={12} onClick={handleClose} />
            </div>
          </div>
          <div className={styles.popover_desc}>
            <span>{t("video_link_modal_desc")}</span>
          </div>
          <div className={styles.popover_img}>
            <video
              className='imageLoading isLight'
              src={withPublicUrl("video/video_link.mp4")}
              poster={withPublicUrl("video/video_link.jpg")}
              autoPlay
              loop
              playsInline
            />
          </div>
          <div className={styles.popover_btn_wrapper}>
            <FTButton
              type='primary'
              className={clsx(styles.popover_btn)}
              onClick={handleToVideo}>
              <span>{t("video_link_modal_btn")}</span>

              <IconArrawRight />
            </FTButton>
          </div>
        </div>
      </section>
    );
  };
  const handleToVideo = () => {
    const { effectElement, uploadImageUrl } = FTImageStore;
    let isProd = process.env.REACT_APP_ENVIRONMENT === "production";
    const resultUrl = (effectElement as HTMLImageElement)?.src ?? "";
    const originUrl = uploadImageUrl || "";
    // https://test-www.fotor.com/apps/ai-video-generator/?type=photo&style=04c2781d-cb64-499d-9542-04788e834665&imageurl=null&rightImageUrl=https://test-u-static.fotor.com/uid_73ab1490ef994488bf8f044a711dfd73/goart-effects/a1b5e76df90347f2945793d4d2aca425.jpg&quality=2&videoDuration=4&generateTemplateId=67aaf23e5f13000089006287
    const link =
      urls.baseUrl +
      `apps/ai-video-generator/?type=photo&imageurl=${originUrl}&rightImageUrl=${resultUrl}&generateTemplateId=${isProd ? "67bbeae0289a080022a4b091" : "67aaf23e5f13000089006287"}`;
    console.log("link", link);
    window.open(link, "_blank");
    handleClose();
  };
  return (
    <div
      className={clsx(styles.video_link_btn, className)}
      data-popoverVisible={popoverVisible}>
      <Popover
        trigger={["click"]}
        placement='bottomRight'
        overlayClassName={clsx(
          styles.video_link_modal_wrapper,
          isMobile && styles.mobile
        )}
        visible={popoverVisible}
        ref={popoverRef}
        {...popoveProps}
        // onVisibleChange={(visible) => {
        //   if (!visible) {
        //     has(visible);
        //   }
        // }}
        content={<FTPopoverContent />}>
        <FTButton
          type='primary'
          className={clsx(
            styles.main_btn
            // popoverVisible && styles.disabled,
          )}
          onClick={handleToVideo}>
          <IconVideo />
          <span className={styles.main_btn_text}>{t("video_link_btn")}</span>
        </FTButton>
      </Popover>
    </div>
  );
}
